import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const CrisisPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const CrisisFirstContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  max-width: 1200px;
  margin: 20px auto;
  margin-top: 60px;
  margin-bottom: 60px;

  @media (max-width: 1350px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const CrisisFirstImage = styled.img`
  width: 60%;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  object-fit: cover;

  @media (max-width: 1350px) {
    margin-right: 10%;
    margin-left: 10%;
    width: 80%;
  }
`;

export const CrisisFirstLine = styled.hr`
  margin-top: 40px;
  opacity: 0.2;
  width: 100%;
  background-color: lightgrey;
  height: 1px;
  border: none;
`;

export const CrisisFirstTextContainer = styled.div`
  margin-left: 20px;

  @media (max-width: 1350px) {
    margin-right: 10%;
    margin-left: 10%;
  }
`;

export const CrisisFirstIntroTitle = styled.h3`
  color: #3393f0;
  letter-spacing: 2px;
  font-size: 14px;
`;

export const CrisisFirstTitle = styled.h1`
  color: #17224d;
  margin-top: 20px;
`;

export const CrisisFirstText = styled.p`
  color: #17224d;
  margin-top: 20px;
`;

export const CrisisSecondContainer = styled.div`
  margin-top: 60px;
  background-image: url("/assets/bg.png");
  background-color: #edf1fc;
  width: 100%;
  padding-bottom: 60px;
`;

export const CrisisSecondTextContainer = styled.div`
  text-align: center;
  margin-top: 60px;
`;

export const CrisisSecondIntroTitle = styled.h3`
  color: #3393f0;
  letter-spacing: 2px;
  font-size: 14px;
  margin-bottom: 20px;
`;

export const CrisisSecondTitle = styled.h1`
  color: #17224d;
  margin-bottom: 20px;
`;

export const CrisisSecondCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  max-width: 1200px;
  margin: 20px auto;

  @media (max-width: 1337px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const CrisisSecondCard = styled.div`
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 36px;
  background: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  min-height: 180px;
  transition: transform 1s ease, background-color 1s ease;

  @media (max-width: 1337px) {
    width: 80%;
    margin: 20px auto;
    min-height: 280px;
  }

  &:hover {
    transform: translateY(-4%);
    background-color: #3393f0;

    h3,
    p {
      color: white;
    }

    div {
      background-color: white;
      color: #17224d;
    }
  }
`;

export const CrisisSecondCardTitle = styled.h3`
  margin-bottom: 20px;
  color: #17224d;
`;

export const CrisisSecondCardIcon = styled(FontAwesomeIcon)`
  font-size: 38px;
  margin-top: 10px;
  margin-bottom: 20px;
  width: 40px;
  color: #3393f0;
  border-radius: 50%;
  background-color: #edf1fc;
  padding: 12px;
`;

export const CrisisSecondCardText = styled.p`
  flex-grow: 1;
  text-align: center;
  font-size: 12px;
  color: #17224d;
`;

export const CrisisThirdWalkthrough = styled.div`
  margin-top: 10%;

  @media (max-width: 800px) {
    margin-top: 15%;
  }
`;

export const CrisisFirstBottomText = styled.div`
  color: #17224d;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const CrisisFirstButton = styled.div`
  background-color: #3393f0;
  width: 40%;
  text-align: center;
  color: white;
  cursor: pointer;
  border-radius: 24px;
  padding: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
`;
